import {
  LabeledText,
  Icon,
  LabeledTextInput,
  ModalButton,
  SyncHeight,
  SyncMultipleHeightProps
} from "adviesbox-shared";
import { connect, FormikContextType } from "formik";
import React, { ReactElement, useCallback } from "react";
import { Algemeen } from "../../.generated/tarieven/tarieventypes";
import LabeledHdnKeuzelijst from "../../shared/components/hdn-keuzelijst/LabeledHdnKeuzelijst";
import { bindSaveFunction } from "../../shared/utils/bind-save-function";
import classes from "../aanvrager-burgelijke-status.module.scss";
import { BurgerlijkeStatusSyncHeightIndex, PersonaliaState } from "../infra/personalia-schema";
import { bindSaveKinderenFunction } from "../kinderen-modal/bind-save-kinderen-function";
import KinderenModal from "../kinderen-modal/kinderen-modal";
import LegitimatiebewijsModal from "../legitimatiebewijs-modal/legitimatiebewijs-modal";
import VerblijfsvergunningModal from "../verblijfsvergunning-modal/verblijfsvergunning-modal";

const Aanvrager1BurgerlijkeStatus = ({
  tarieven,
  formik: { values, setFieldValue },
  sourceRef,
  targetRef
}: {
  tarieven: Algemeen;
  formik: FormikContextType<PersonaliaState>;
} & SyncMultipleHeightProps): ReactElement => {
  const createSaveFunction = useCallback(bindSaveFunction(setFieldValue), [setFieldValue]);
  const saveKinderenFunction = useCallback(bindSaveKinderenFunction(setFieldValue, 1), [setFieldValue]);

  const alleKinderen = values.aanvrager1BurgerlijkeStatus.kinderen.concat(
    values.medeAanvragerOpties.medeAanvrager
      ? values.aanvrager2BurgerlijkeStatus.kinderen.filter(kind => kind.gezamenlijkKind)
      : []
  );
  return (
    <SyncHeight
      sourceRef={sourceRef && sourceRef[BurgerlijkeStatusSyncHeightIndex.All]}
      targetRef={targetRef && targetRef[BurgerlijkeStatusSyncHeightIndex.All]}
    >
      <LabeledHdnKeuzelijst
        caption="Legitimatiebewijs"
        name="aanvrager1BurgerlijkeStatus.legitimatiebewijs.soortLegitimatiebewijs"
        berichtSoortType="AX"
        keuzelijst="LegitimatieSoortType"
        emptyValue="Geen"
        fieldSize="xl"
        appendChildren={
          <ModalButton
            resetSize={true}
            parent="aanvrager1BurgerlijkeStatus.legitimatiebewijs"
            content={<Icon name="specificatie" alt="Legitimatiebewijs" />}
          >
            <LegitimatiebewijsModal
              data={values.aanvrager1BurgerlijkeStatus.legitimatiebewijs}
              onSave={createSaveFunction("aanvrager1BurgerlijkeStatus.legitimatiebewijs")}
            />
          </ModalButton>
        }
      />
      <LabeledHdnKeuzelijst
        caption="Verblijfsvergunning"
        name="aanvrager1BurgerlijkeStatus.verblijfsvergunning.soortVerblijfsvergunning"
        berichtSoortType="AX"
        keuzelijst="VerblijfsVergunningType"
        emptyValue="Geen"
        fieldSize="xl"
        appendChildren={
          <ModalButton
            resetSize={true}
            parent="aanvrager1BurgerlijkeStatus.verblijfsvergunning"
            content={<Icon name="specificatie" alt="Verblijfsvergunning" />}
          >
            <VerblijfsvergunningModal
              data={values.aanvrager1BurgerlijkeStatus.verblijfsvergunning}
              onSave={createSaveFunction("aanvrager1BurgerlijkeStatus.verblijfsvergunning")}
            />
          </ModalButton>
        }
      />
      <SyncHeight
        sourceRef={sourceRef && sourceRef[BurgerlijkeStatusSyncHeightIndex.Iban]}
        targetRef={targetRef && targetRef[BurgerlijkeStatusSyncHeightIndex.Iban]}
      >
        <LabeledTextInput
          caption="IBAN"
          name="aanvrager1BurgerlijkeStatus.iban"
          className={classes.ibanuppercase}
          fieldSize="xl"
        />
      </SyncHeight>
      {/* <LabeledBevestigingInput
        caption="Gezamelijke rekening"
        name="aanvrager1BurgerlijkeStatus.gezamelijkeRekening"
      /> */}
      <LabeledHdnKeuzelijst
        caption="Burgerlijke staat"
        name="aanvrager1BurgerlijkeStatus.burgerlijkeStaat"
        berichtSoortType="AX"
        keuzelijst="BurgerlijkeStaatType"
        fieldSize="xl"
      />
      <LabeledTextInput caption="Geboorteplaats" name="aanvrager1BurgerlijkeStatus.geboorteplaats" />
      <LabeledText
        caption="Kinderen"
        value={`${alleKinderen.length}`}
        name="aanvrager1BurgelijkeStatus.kinderen"
        fieldSize="xl"
        appendChildren={
          <ModalButton
            resetSize={true}
            parent="aanvrager1BurgerlijkeStatus.kinderen"
            content={<Icon name="specificatie" alt="Kinderen" />}
          >
            <KinderenModal
              tarieven={tarieven}
              data={alleKinderen}
              onSave={saveKinderenFunction(values)}
              medeaanvrager={values.medeAanvragerOpties.medeAanvrager}
            />
          </ModalButton>
        }
      />
    </SyncHeight>
  );
};

export default connect<{ tarieven: Algemeen } & SyncMultipleHeightProps, PersonaliaState>(Aanvrager1BurgerlijkeStatus);
